/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAdvanceSettings } from '../../models/profile-advance-settings';
import { ProfileResponse } from '../../models/profile-response';

export interface ChangeAdvanceSettingsByProfileId$Params {
  id: number;
      body: ProfileAdvanceSettings
}

export function changeAdvanceSettingsByProfileId(http: HttpClient, rootUrl: string, params: ChangeAdvanceSettingsByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
  const rb = new RequestBuilder(rootUrl, changeAdvanceSettingsByProfileId.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileResponse>;
    })
  );
}

changeAdvanceSettingsByProfileId.PATH = '/rest/profile/{id}/advance-settings';
